const injectGTM = () => {
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-KVCQ6JB'; //GTM-KVCQ6JB
  script.type = 'text/javascript';
  script.async = true;

  document.head.appendChild(script);
  console.info('gtm loaded');
};

const dataLayer = window.dataLayer || [];

const getPageTitle = () => {
  if (window.location.hash !== "") {
    return window.location.pathname.replace(/-/g, ' ').replace(/\//g, '') + ((window.location.pathname.replace(/-/g, ' ').replace(/\//g, '') + window.location.hash.replace(/\#/g, '').replace(/\//g, ' ').replace(/-/g, ' ')).split(' ')[1] !== '' ? ' - ' + window.location.hash.replace(/\#/g, '').replace(/\//g, ' ').replace(/-/g, ' ').trim() : '');
  } else {
    return window.location.pathname.substring(1).replace(/-/g, ' ').split('/')[0] + (window.location.pathname.substring(1).split('/')[1] !== '' ? ' - ' + window.location.pathname.substring(1).replace(/-/g, ' ').split('/').slice(1).join(' ').trim() : '');
  }
};

export {
  injectGTM,
  dataLayer,
  getPageTitle,
};
